import { render, staticRenderFns } from "./already-distribute-case.vue?vue&type=template&id=21549478&scoped=true"
import script from "./already-distribute-case.vue?vue&type=script&lang=ts"
export * from "./already-distribute-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21549478",
  null
  
)

export default component.exports